var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"mini","icon":"el-icon-download"},on:{"click":_vm.download}})
}
var staticRenderFns = []

export { render, staticRenderFns }